// Navigate the top-level window to a URL, escaping any preview iframe.
//
// Google's accounts.google.com sets X-Frame-Options: DENY, so any in-frame
// navigation results in ERR_BLOCKED_BY_RESPONSE. Programmatically clicking
// an <a target="_top"> is the only method browsers guarantee will pop out
// of an iframe (window.top.location can be silently blocked by sandboxing).
export function openTopLevel(url) {
  const a = document.createElement("a");
  a.href = url;
  a.target = "_top";
  a.rel = "noopener noreferrer";
  // Must be in the DOM for the click to be honored by all browsers
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    try { document.body.removeChild(a); } catch { /* noop */ }
  }, 0);
}
